// pages/unauthorized.jsx

import React, { useEffect } from 'react';

function Unauthorized() {
    useEffect(() => {
        const canvas = document.getElementById('backgroundCanvas');
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        let stars = [];
        const FPS = 60;
        let mouse = { x: 0, y: 0 };

        for (let i = 0; i < 100; i++) {
            stars.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 1 + 1,
                vx: Math.floor(Math.random() * 50) - 25,
                vy: Math.floor(Math.random() * 50) - 25
            });
        }

        function draw() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = "lighter";

            stars.forEach((star) => {
                ctx.fillStyle = "#fff";
                ctx.beginPath();
                ctx.arc(star.x, star.y, star.radius, 0, 2 * Math.PI);
                ctx.fill();
                ctx.fillStyle = 'black';
                ctx.stroke();
            });

            stars.forEach((starI) => {
                ctx.moveTo(starI.x, starI.y);
                if (distance(mouse, starI) < 150) ctx.lineTo(mouse.x, mouse.y);
                stars.forEach((starII) => {
                    if (distance(starI, starII) < 150) {
                        ctx.lineTo(starII.x, starII.y);
                    }
                });
            });

            ctx.lineWidth = 0.05;
            ctx.strokeStyle = 'white';
            ctx.stroke();
        }

        function update() {
            stars.forEach((star) => {
                star.x += star.vx / FPS;
                star.y += star.vy / FPS;

                if (star.x < 0 || star.x > canvas.width) star.vx = -star.vx;
                if (star.y < 0 || star.y > canvas.height) star.vy = -star.vy;
            });
        }

        function tick() {
            draw();
            update();
            requestAnimationFrame(tick);
        }

        function distance(point1, point2) {
            let xs = point2.x - point1.x;
            xs *= xs;
            let ys = point2.y - point1.y;
            ys *= ys;
            return Math.sqrt(xs + ys);
        }

        canvas.addEventListener('mousemove', (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
        });

        tick();

        return () => {
            canvas.removeEventListener('mousemove', mouse);
        };
    }, []);

    return (
      <div className='unauthorized'>
          <h1 className='custom-h1 margin-top-spacer-60'>You got lost</h1>
          <h2 className='custom-h2 margin-top-spacer-60'>You may want to go to one of these</h2>
          <canvas className="unauthorized-canvas" id="backgroundCanvas"></canvas>
          <div className="links-container">
              <a className="lost" href="/">Home</a>
              <a className="lost" href="/login">Login</a>
          </div>
      </div>
  );
}

export default Unauthorized;
